module.exports = __webpack_public_path__ + "img/sv99.04aeaa77.svg";